import React from 'react';
import { Container, Row } from 'react-grid-system';
import { FLASH_MESSAGE_TIMEOUT, useFlashMessage } from '../../containers/FlashMessage';
import Button from '../Button';
import FlashMessage from '../FlashMessage';
import Modal from '../Modal';
import { Header3, P1 } from '../Typography';
import { CREATE_EVIDENCE_CHASERS_STORE_KEY } from '../../redux/claim/claim.actions';

interface CreateEvidenceChasersModalProps {
  onDismiss: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

const CreateEvidenceChasersModal: React.FC<CreateEvidenceChasersModalProps> = ({ onDismiss, onSubmit, isSubmitting }) => {
  const [flashMessagePayload, dismissFlashMessage] = useFlashMessage([CREATE_EVIDENCE_CHASERS_STORE_KEY]);
  return (
    <Modal onDismiss={onDismiss}>
      {flashMessagePayload ? (
        <FlashMessage payload={flashMessagePayload} onDismiss={dismissFlashMessage} timeRemaining={FLASH_MESSAGE_TIMEOUT} />
      ) : null}
      <Header3 style={{ marginBottom: 15 }}>Create Evidence Chasers</Header3>
      <P1 style={{ marginBottom: 20 }}>Are you sure you would like to create evidence chasers?</P1>
      <>
        <Container fluid>
          <Row style={{ display: 'flex', justifyContent: 'flex-end', columnGap: '8px', paddingTop: '24px' }}>
            <Button buttonType="secondary" noArrow={true} onClick={onDismiss}>
              Cancel
            </Button>
            <Button disabled={isSubmitting} onClick={onSubmit}>
              Confirm
            </Button>
          </Row>
        </Container>
      </>
    </Modal>
  );
};

export default CreateEvidenceChasersModal;
